import * as React from 'react';
import { useSelector } from 'react-redux';

import { SearchSuggestIcon } from '../../../components/SearchSuggest';
import { selectSuggestions } from '../../../selectors/suggestions';
import { MIN_CHARS_TO_DISPLAY_SUGGEST } from '../constants';

export const useSuggestions = (value: string) => {
  const suggestions = useSelector(selectSuggestions);

  return React.useMemo(() => {
    if (value.length < MIN_CHARS_TO_DISPLAY_SUGGEST) {
      return [];
    }

    const suggestionList = suggestions || [];

    return suggestionList.map(suggestion => {
      const { title, subtitle, imageUrl } = suggestion;

      return {
        title,
        subtitle,
        value: suggestion,
        leftIcon: <SearchSuggestIcon imageUrl={imageUrl} />,
      };
    });
  }, [suggestions, value]);
};
